import request from '@/router/axios';

const getList = (current, size, params) => request({
  // url: '/api/mcc-staff/vacationInfo/page',
  url: '/api/mcc-base/baseVacationInfo/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  // url: '/api/mcc-staff/vacationInfo/vacationSave',
  url: '/api/mcc-base/baseVacationInfo/vacationSave',
  method: 'post',
  data: params,
})

const detail = params => request({
  // url: '/api/mcc-staff/vacationInfo/detail',
  url: '/api/mcc-base/baseVacationInfo/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  // url: '/api/mcc-staff/vacationInfo/vacationSave',
  url: '/api/mcc-base/baseVacationInfo/update',
  method: 'post',
  data: params,
})

const remove = id => request({
  // url: '/api/mcc-staff/vacationInfo/vacationRemove',
  url: '/api/mcc-base/baseVacationInfo/vacationRemove',
  method: 'post',
  params: {
    vacationInfoId: id,
  },
})

// 假期规则列表
const vacationLeaveList = params => request({
  url: '/api/mcc-base/basevacationrulevalue/getVacationRule',
  method: 'get',
  params: {
    ...params,
  },
})

// 获取假期规则列字段
const vacationRuleRowList = params => request({
  url: '/api/mcc-base/basevacationrule/page',
  method: 'get',
  params: {
    ...params,
  },
})
// 规则列
const vacationAnnualRuleList = params => request({
  url: '/api/mcc-base/basevacationrule/ruleList',
  method: 'get',
  params: {
    ...params,
  },
})

const saveVacationRuleList = params => request({
  url: '/api/mcc-base/basevacationrulevalue/saveOrUpdateList',
  method: 'post',
  data: params,
  // data: {
  //   ...params,
  // },
})

// 删除请假规则
const removeVacationRule = params => request({
  url: '/api/mcc-base/basevacationrulevalue/removeRule',
  method: 'post',
  params: {
    ...params,
  },
})

const initVacationInfo = params => request({
  url: '/api/mcc-base/baseVacationInfo/initialize',
  method: 'post',
  params: {
    ...params,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
  vacationLeaveList,
  vacationRuleRowList,
  vacationAnnualRuleList,
  saveVacationRuleList,
  removeVacationRule,
  initVacationInfo,
}
